import {requestIdleCallback} from '@servicenow/ui-utils';
import log from '../log';

const styleSheetsContent = {};
const PREFIX = 'SEISMIC_STYLES';

const get = (version, tagName) => {
	let contents = styleSheetsContent[tagName];
	if (contents) return contents;

	try {
		const errorText = `<title>Error</title>`;
		contents = localStorage.getItem(`${PREFIX}_${tagName}${version}`);
		if (contents.includes(errorText)) contents = '';
	} catch (e) {
		log(`The stylesheets content for the tag, ${tagName}, could not be retrieved.`);
	}

	return contents;
};

const set = (version, tagName, contents) => {
	try {
		styleSheetsContent[tagName] = contents;
		requestIdleCallback(() => {
			localStorage.setItem(`${PREFIX}_${tagName}${version}`, contents);
		});
	} catch (e) {
		log(`The stylesheets content for the custom element, ${name}, could not be cached.`);
	}
};

export default {set, get};
